const TStrings = {
    QUESTION_CATEGORY_CONTACT_INFO: 'Contact Info',
    QUESTION_CATEGORY_TEXT: 'Text',
    QUESTION_CATEGORY_CHOICE: 'Choice',
    QUESTION_CATEGORY_SCHEDULING: 'Scheduling',
    QUESTION_CATEGORY_SELLING: 'Selling',
    QUESTION_CATEGORY_DISPLAY: 'Display',
    QUESTION_CATEGORY_LEGAL: 'Legal',
    QUESTION_CATEGORY_LOGIN: 'Login',
    QUESTION_THANK_YOU_CATEGORY_CONFIRMATION: 'Confirmation',
    QUESTION_THANK_YOU_CATEGORY_DISPLAY: 'Display',
    QUESTION_INVOICE_CATEGORY: 'Invoice',
};

export default TStrings;
